<template>
  <section class="section is-medium">
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column has-text-centered">
          <h1 class="title">Offline</h1>
          <p class="subtitle">Your internet connection is currently offline</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    reload () {
      window.location.reload(true);
    }
  }
}
</script>